import { ColorNordicGrey4 } from 'autogen/design-tokens/tokens';
import ProductFavoriteButton from 'components/generic/productFavoriteButton';
import type { IProductFavoriteButton } from 'components/generic/productFavoriteButton/ProductFavoriteButton';
import styled from 'styled-components';

const StyledProductFavoriteButton = styled(ProductFavoriteButton)`
`;

export default function FavoriteItemButton({
    productId,
    initialFavoriteState,
    ...restProps
}: {
    productId: number;
    initialFavoriteState: IProductFavoriteButton['initialFavoriteState'];
}) {
    return (
        <StyledProductFavoriteButton
            productId={productId}
            initialFavoriteState={initialFavoriteState}
            uaTrackingCategory="basket"
            variant="secondary"
            {...restProps}
        />
    );
}
